import IconTooltip from './IconTooltip';
import SystemIconModifier, { type SystemIconProps } from './SystemIcon';

function SingleSelect(props: SystemIconProps) {
  const { isSystem } = props;
  return (
    <IconTooltip isSystem={isSystem}>
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium fs-exclude"
        focusable="false"
        aria-hidden="true"
        data-testid="SingleSelectIcon"
        data-dd-action-name="FIM 3 Custom Field - icon redacted"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="4" fill="#CDC1E6" />
        <path
          d="M14.0001 7.33366C17.6751 7.33366 20.6667 10.3253 20.6667 14.0003C20.6667 17.6753 17.6751 20.667 14.0001 20.667C10.3251 20.667 7.33341 17.6753 7.33341 14.0003C7.33341 10.3253 10.3251 7.33366 14.0001 7.33366ZM14.0001 5.66699C9.40008 5.66699 5.66675 9.40033 5.66675 14.0003C5.66675 18.6003 9.40008 22.3337 14.0001 22.3337C18.6001 22.3337 22.3334 18.6003 22.3334 14.0003C22.3334 9.40033 18.6001 5.66699 14.0001 5.66699ZM14.0001 16.5003L10.6667 13.167H17.3334L14.0001 16.5003Z"
          fill="#6B5499"
        />
        {isSystem && SystemIconModifier()}
      </svg>
    </IconTooltip>
  );
}

export default SingleSelect;
